import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import debounce from 'lodash/debounce';
import FauxButton from './FauxButton';
import TextField from '../molecules/TextField';
import css from './CopyArea.css';

const CopyArea = ({
    containerStyle = {},
    label = '',
    copyText = '',
    copiedText = '',
    type = null,
    content = '',
    onCopyClicked = () => {},
    disabled = false,
}) => {
    const textField = useRef(null);
    const [copying, setCopying] = useState(false);
    const [value, setValue] = useState(content);

    useEffect(() => {
        setValue(content);
    }, [content]);

    const onCopyButtonClick = () => {
        try {
            setCopying(true);
            navigator.clipboard.writeText(value);
            setTimeout(() => {
                setCopying(false);
            }, 2000);
            if (onCopyClicked) {
                onCopyClicked(value, label);
            }
        } catch (e) {}
    };

    const isSmall = type === 'small';

    return (
        <div className={`${css.container} ${css[type]}`} style={containerStyle}>
            <div className={css.topArea}>
                <div className={css.label}>
                    <Translate id={label} />
                </div>
                <FauxButton onClick={onCopyButtonClick} disabled={copying} className={css.button}>
                    <Translate id={copying && copiedText ? copiedText : copyText} />
                </FauxButton>
            </div>
            <div>
                <TextField
                    type={isSmall ? 'text' : 'textarea'}
                    value={value}
                    ref={textField}
                    disabled={disabled}
                    inputConfig={
                        isSmall
                            ? {}
                            : {
                                  style: {
                                      resize: 'none',
                                      height: '115px',
                                  },
                              }
                    }
                    onChange={debounce(newValue => setValue(newValue))}
                />
            </div>
        </div>
    );
};

CopyArea.propTypes = {
    containerStyle: PropTypes.objectOf(PropTypes.any),
    type: PropTypes.oneOf(['small', 'large', null]),
    label: PropTypes.string,
    copyText: PropTypes.string,
    copiedText: PropTypes.string,
    content: PropTypes.string,
    onCopyClicked: PropTypes.func,
    disabled: PropTypes.bool,
};

export default CopyArea;
